import {Component, EventEmitter, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Vessel, VesselsService} from '../vessels.service';
import {Observable} from 'rxjs';
import moment from 'moment';
import {VesselBudget, VesselManagementService} from '../services/vessel-management.service';
import {MessageLevel, PgMessagesService} from '../../../shared/services/pg-messages.service';
import {PgTitleComponent} from '../../../shared/components/title-bar/title-bar.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AgGridService } from 'src/app/shared/ag-grid/ag-grid.service';

@Component({
  selector: 'app-vessel-management-cost',
  templateUrl: './vessel-management-cost.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports:[SharedModule, AgGridModule]
})
export class VesselManagementCostComponent implements OnInit, PgTitleComponent {

  title: EventEmitter<string> = new EventEmitter();

  budgets!: Observable<VesselBudget[]>;
  vessels!: Observable<Vessel[]>;
  vessel!: Vessel;
  years: number[] = [];
  selectedYear!: number;
  selectedQuarter!: string;
  daily!: number;

  gridOptions: GridOptions = {};

  constructor(private _vesselsService: VesselsService,
              private _vesselManagementService: VesselManagementService,
              private _pgMessagesService: PgMessagesService) { }

  columnDefs = [
    { headerName: 'Vessel', field: 'vesselName' },
    { headerName: 'Year', field: 'year' },
    { headerName: 'Quarter', field: 'quarter'},
    { headerName: 'Daily budget', field: 'dailyCost' },
  ];

  ngOnInit() {
    this.gridOptions = AgGridService.getOptions();
    this.title.emit('Vessels Daily budget');
    this.vessels = this._vesselsService.getActiveVessels();
    this.budgets = this._vesselManagementService.getBudgets();
    const thisYear = moment().year();
    this.years = Array.of(thisYear - 1, thisYear, thisYear + 1);
  }

  gridSetting(event: GridReadyEvent) {
    AgGridService.setting(event);
  }

  addBudget() {
    const vesselBudget: VesselBudget = {
      vesselName: this.vessel.name!.name,
      vesselImo: this.vessel.imo,
      year: this.selectedYear,
      quarter: this.selectedQuarter,
      dailyCost: this.daily
    };

    this._vesselManagementService.saveBudget(vesselBudget).subscribe(() => {
      this._pgMessagesService.publishMessage({
        message: 'Successfully saved budget',
        topic: 'Vessel budget',
        level: MessageLevel.Info
      });
      this.budgets = this._vesselManagementService.getBudgets();
    }, () => {
      this._pgMessagesService.publishMessage({
        message: 'Failed to save budget',
        topic: 'Vessel budget',
        level: MessageLevel.Error
      });
    });
  }
}
